<template>
    <div class="tw-aside" :style="style" v-show="store.state.activeSubmenus?.length">
        <slot></slot>
    </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'tw-aside',
    props: {
        width: {
            type: String,
            default: null,
        }
    },
    setup(props) {
        const store = useStore()

        return {
            store,
            style: computed(() => {
                return props.width
                ? ({ '--tw-aside-width': props.width })
                : {}
            }),
        }
    },
}
</script>

<style>

</style>